<template>
  <div class="flex flex-col px-2 py-4 bg-white border-b border-t border-solid border-grey-lightest" v-if="showSetUpConsultationFollowUp || showSetUpLabFollowUp">
    <div class="flex flex-col mt-2 mx-2 flex-no-shrink flex-no-grow">
      <label class="text-sm font-semibold text-grey-dark mb-2 mr-1 tracking-wide" style="text-transform: uppercase">Follow up for {{customer.name}}</label>
    </div>
    <div class="flex flex-col rounded-xs bg-grey-extralight py-4 px-3 mt-2 mx-2 flex-no-shrink flex-no-grow">
      <label class="text-sm font-semibold text-grey-dark mb-4">Follow up for</label>
      <div class="flex flex-col mb-6" v-if="showSetUpLabFollowUp">
        <div class="flex flex-row items-center">
          <input class="flex m-1 mb-2" type="checkbox" v-model="testsChecked"/> 
          <div class="flex ml-1 text-sm font-semibold text-grey-darkest">Lab Tests</div>
        </div>
        <div class="flex flex-col mt-1">
          <div class="flex flex-row" >
            <div class="flex appearance-none w-64 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"></div>
            <div class="flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue">After</div>
            <div class="flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"></div>
          </div>
          <div v-for="(test, i) in recommendedTests" :key="i" class="flex flex-row mb-3">
            <!-- <select class="flex appearance-none w-64 h-8 pl-2 mr-4 bg-white border border-solid rounded-xs border-grey text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
              <option value="Chest X-Ray">{{test.package_name}}</option>
            </select> -->
            <label class="text-sm text-grey-dark w-64 h-6 self-center pl-2 mr-4">{{test.package_name}}</label>
            <select v-model="test.days" :disabled="testsChecked ? false : true" @change="labFollowupSelect" class="flex appearance-none w-24 h-8 pl-2 mr-1 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
              <option value="0">Select</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="7">7</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="45">45</option>
              <option value="60">60</option>
              <option value="90">90</option>
            </select>
            <select class="flex appearance-none w-24 h-8 pl-2 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
              <option value="days">days</option>
            </select>
          </div>
        </div>
        <!-- <div class="flex cursor-pointer items-center mt-3">
          <img @click="addFollowUp()" class="w-6 h-6 cursor-pointer" src="../../assets/add_black.svg">
          <label class="text-sm text-grey-dark ml-2" for="">Add follow up</label>
        </div> -->
      </div>
      <div v-if="showSetUpConsultationFollowUp">
        <!-- <div @click="followUpFor('consultation')" class="p-2 px-3 text-xs relative rounded-xs border border-solid border-blue cursor-pointer" >Consultation</div> -->
        <div class="flex flex-row items-center">
          <input class="flex m-1 mb-2" type="checkbox" v-model="consultationChecked"/> 
          <div class="flex ml-1 text-sm font-semibold text-grey-darkest">Consultation</div>
        </div>
        <div class="flex flex-col mt-1">
          <div class="flex flex-row">
            <div class="flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue">After</div>
            <div class="flex appearance-none w-24 pb-2 pl-2 text-sm text-grey-darker focus:border-blue"></div>
          </div>
          <div class="flex flex-row mb-3">
            <select v-model="followUpConsultDays" @change="consultationFollowupSelect" :disabled="consultationChecked ? false : true" class="flex appearance-none w-24 h-8 pl-2 mr-1 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
              <option value="0">Select</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="7">7</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="45">45</option>
              <option value="60">60</option>
              <option value="90">90</option>
            </select>
            <select class="flex appearance-none w-24 h-8 pl-2 bg-white border border-solid rounded-xs border-grey-lightest text-sm text-grey-darkest focus:border-blue" name="dosage type" style="outline: none;  background-position: 4.4rem 0.5rem; background-repeat: no-repeat; background-size: 0.9rem 0.9rem">
              <option value="days">days</option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex mt-4">
        <div @click="setUpFollowUp()" class="flex px-4 py-3 w-32 text-xs justify-center font-semibold rounded-sm text-white" v-bind:class="enableSetFollowupButton ? 'bg-blue cursor-pointer' : 'bg-grey-lightest cursor-not-allowed'">Set follow up</div>
      </div>
    </div>
    <div class="flex mx-4 py-2">
      <p class="text-xs text-grey-dark">Reminder will be sent to {{customer.name}} 48 hours before the event to schedule a follow up consultation</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  components: {
  },
  props: ['consultType'],
  data () {
    return {
      testsChecked: false,
      consultationChecked: false,
      followUpConsultDays: '0',
      enableSetFollowupButton: false
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    recommendedTests: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.recommendedTests) {
        this.customer.consultation.recommendedTests.map(function (t) {
          t.days = '0'
        })
        return this.customer.consultation.recommendedTests
      }
      return []
    },
    showSetUpLabFollowUp: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders && this.customer.consultation.followupReminders.length > 0) {
        let r = this.customer.consultation.followupReminders.find(function (f) {
          if (f.followup_type === 'lab_test') return f
        })
        if (!r && this.recommendedTests.length > 0) return true
        return false
      } else if (this.recommendedTests.length > 0) {
        return true
      }
      return false
    },
    showSetUpConsultationFollowUp: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.followupReminders && this.customer.consultation.followupReminders.length > 0) {
        let r = this.customer.consultation.followupReminders.find(function (f) {
          if (f.followup_type === 'consultation') return f
        })
        if (!r) return true
        return false
      }
      return true
    },
    testFollowupReminders: function () {
      let that = this
      if (that.customer && that.customer.consultation && that.customer.consultation.followupReminders) {
        let followupReminders = that.customer.consultation.followupReminders.filter(function (ele) {
          return (ele.followup_type === 'lab_test')
        })
        followupReminders.map(function (r) {
          let t = that.customer.consultation.recommendedTests.find(function (ele) {
            return (ele.test_id === r.recommended_test_id)
          })
          if (t) {
            r.package_name = t.package_name
          } else {
            r.package_name = 'NA'
          }
          return r
        })
        return followupReminders
      }
      return []
    }
  },
  watch: {
    customer: function (newV, oldV) {
      if (newV !== oldV) {
        this.enableSetFollowupButton = false
        // this.newLabTestFollowUp = {}
        // this.newConsultationFollowUP = {}
        this.consultationChecked = false
        this.followUpConsultDays = '0'
      }
    }
  },
  methods: {
    labFollowupSelect: function (e) {
      if (e.target.value !== '0') {
        this.enableSetFollowupButton = true
      }
    },
    consultationFollowupSelect: function (e) {
      if (e.target.value !== '0') {
        this.enableSetFollowupButton = true
      }
    },
    followUpFor: function (type) {
      if (type === 'consultation' && !this.showSetUpConsultationFollowUp) {
        this.$toast.open({
          message: 'Follow up for consultation is already scheduled',
          type: 'warning',
          position: 'top',
          queue: true
        })
      } else if (type === 'lab_test' && !this.showSetUpLabFollowUp) {
        this.$toast.open({
          message: 'Follow up for lab tests is already scheduled',
          type: 'warning',
          position: 'top',
          queue: true
        })
      }
    },
    setUpFollowUp: function () {
      if (!this.enableSetFollowupButton) {
        return
      }
      let followUps = []
      if (!this.customer.consultation.date) {
        this.$toast.open({
          message: 'Consultation date not found',
          type: 'error',
          position: 'top',
          queue: true
        })
        return
      }
      let createdAt = new Date(this.customer.consultation.date)
      if (this.testsChecked) {
        if (this.testFollowupReminders.length < 1) {
          let a = []
          let allTestSelected = true
          this.recommendedTests.map(function (test) {
            let scheduledTime = new Date(createdAt)
            if (test.days === '0') {
              allTestSelected = false
              return
            }
            let date = createdAt.getDate() + JSON.parse(test.days)
            scheduledTime.setDate(date)
            a.push({recommended_test_id: test.test_id, followup_type: 'lab_test', scheduled_time: scheduledTime})
          })
          if (!allTestSelected) {
            this.$toast.open({
              message: 'Please schedule follow for all the tests',
              type: 'warning',
              position: 'top',
              queue: true
            })
            return
          }
          followUps = followUps.concat(a)
        }
      }
      if (this.consultationChecked) {
        let scheduledTime = new Date(createdAt)
        let date = createdAt.getDate() + JSON.parse(this.followUpConsultDays)
        scheduledTime.setDate(date)
        followUps.push({followup_type: 'consultation', scheduled_time: scheduledTime})
        if (this.followUpConsultDays < 1) {
          this.$toast.open({
            message: 'Please select a day for consultation',
            type: 'warning',
            position: 'top',
            queue: true
          })
          return
        }
      }
      if (this.consultType === 'offline') {
        this.$store.dispatch('pastOfflineConsultation/setFollowUp', followUps)
      } else {
        this.$store.dispatch('pastConsultation/setFollowUp', followUps)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Customer/FollowUp/SetUp.vue